import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Typography, message, Spin } from 'antd';
import { useMutation } from '@apollo/client';
import RoleForm from './RoleForm';
import { scopesWithLevel, scopesWithNoLevel } from '../../../utils/scopes';
import {
  ADD_OVERRIDDEN_SCOPES_BY_ROLE,
  GET_OVERRIDDEN_SCOPES_BY_ROLE,
} from '../../../gql/projectCategories';

const { Text } = Typography;

const TabRolesAdd = () => {
  const { id } = useParams();
  const history = useHistory();
  const [addRole, { loading: mutationLoading }] = useMutation(
    ADD_OVERRIDDEN_SCOPES_BY_ROLE,
    {
      refetchQueries: [
        {
          query: GET_OVERRIDDEN_SCOPES_BY_ROLE,
          variables: { ids: [id], state: 'ALL' },
        },
      ],
      onCompleted: ({ addOverriddenScopesByRoleInProjectCategory }) => {
        history.push(`/system-setting/project-categories/${id}/roles`);
        message.success(
          `Overriden scope in ${addOverriddenScopesByRoleInProjectCategory.name} successfully added`
        );
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  return (
    <>
      <Text
        type="secondary"
        style={{ display: 'block', paddingBottom: '16px' }}
      >
        Add override the access right of roles in the project category
      </Text>
      <Spin spinning={mutationLoading} tip="Adding...">
        <RoleForm
          onFinish={(input) => {
            const getScopesFromInput = (scopes) => [
              ...scopesWithNoLevel(scopes),
              ...scopesWithLevel(scopes),
            ];
            const scopes = getScopesFromInput(input);
            // console.log(scopes);
            addRole({
              variables: {
                input: {
                  projectCategory: id,
                  role: input.role,
                  scopes,
                },
              },
            });
          }}
        />
      </Spin>
    </>
  );
};

export default TabRolesAdd;
